import { compose } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import withReduxCreate, {
  withCreateInitialValues,
  withState,
} from './formCreate'
import CreateReservation from './CreateReservation'
import withReduxUpdate, { withUpdateInitialValues } from './formUpdate'
import { withRouter } from 'react-router'

export enum FormNames {
  Create = 'create_reservation',
  Update = 'update_reservation',
}

export default {
  Create: compose(
    withCreateInitialValues,
    withState,
    withReduxCreate(FormNames.Create),
    withTranslation(),
  )(withRouter(CreateReservation) as any),
  Update: compose(
    withUpdateInitialValues,
    withReduxUpdate(FormNames.Update),
    withTranslation(),
  )(withRouter(CreateReservation) as any),
}
